import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { IconButton, Tabs, Tab, Typography, Avatar, Badge, Box } from '@mui/material';

import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { tokens } from 'theme/tokens';

const CTTabs = ({
  labels,
  counts,
  tabIndex,
  addNewButtonEnabled,
  removeButtonEnabled,
  fnOnAddTabHandler,
  fnOnRemoveTabHandler,
  fnOnTabChangeHandler,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const tabElement = labels.map((label, index) => {
    let tabName = label;
    if (removeButtonEnabled && index !== 0) {
      tabName = (
        <Box display={'flex'} alignItems={'center'}>
          <Typography variant='body1'>{label}</Typography>
          <IconButton aria-label='remove' sx={{color: colors.error.main}} size='small'>
            <RemoveCircleOutlineOutlinedIcon
              fontSize='small'
              onClick={() => fnOnRemoveTabHandler(label)}
            />
          </IconButton>
        </Box>
      );
    }
    let tabContent=tabName;
    if (counts) {
      const statusCount = counts.find((item) => item.status === label);
      const bgColor = tabIndex === index ? colors.primary.main : colors.primary.light;
      if (statusCount) {
        tabContent = (
          <Box
            component='span'
            display={'flex'}
          >
            {tabName}<Avatar variant='body1'
              sx={{
                width: '22px',
                height: '22px',
                background: bgColor,
                marginLeft: 1,
                fontWeight: 600,
                textAlign: 'center'
              }}
            >
              <Typography variant='caption' fontWeight={500}> {statusCount.count}</Typography>
            </Avatar>
          </Box>          
        )
      }
    }
    return <Tab
      key={`key-${index}-${label}`}
      tabIndex={index}
      label={tabContent}
      sx={{
        padding: '4px',
        color: colors.neutral[400],
        '&.Mui-selected': {
          color: colors.base.black,
          fontWeight: 600,
        }
      }}
    />;
  });

  return (
    <Tabs
      value={tabIndex}
      indicatorColor='primary'
      textColor={colors.neutral[400]}
      onChange={(evt, tabIndex) => fnOnTabChangeHandler(tabIndex, evt)}
    >
      {tabElement}
      {addNewButtonEnabled && (
        <IconButton aria-label='add' color='primary' size='large'>
          <AddCircleOutlineOutlinedIcon fontSize='small' onClick={fnOnAddTabHandler} />
        </IconButton>
      )}
    </Tabs>
  );
};

export default CTTabs;